import { getCurrencySymbol } from '@src/utilities/currency';

interface PriceProps {
  price: number | string;
  currency: string;
  className?: string;
}
export function Price({ price, currency, className }: PriceProps) {
  const numericPrice = isNaN(Number(price)) ? 0 : Number(price);

  const formattedPrice = parseFloat(Math.abs(numericPrice).toFixed(2));
  const sign = numericPrice < 0 ? '-' : '';

  return (
    <span className={className}>
      {sign}
      {getCurrencySymbol(currency)}
      {formattedPrice}
    </span>
  );
}
